import { useState, useEffect } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { pepApiRequest, RequestMethod } from 'src/services';
import { Add } from '@mui/icons-material';
import { useUserRoles } from 'src/auth';
import { SiteItemStatus as SiteStatus } from 'src/pages/Sites/types';
import { useModal } from 'src/hooks';
import {
  DataTableWrapper,
  DataTableWrapperActionButton,
} from 'src/components/DataTable';
import { PageCardLoader } from 'src/components/PageCardLayout';
import { Box, Typography } from '@mui/material';
import {
  API_SITE_CLUSTERS,
  API_SITE_UPDATE_SITE_STATUS,
} from '../../constants';
import { SiteItemStatus as Status } from '../../types';
import { useSiteDetails } from '../../redux';
import SiteClusterCreateModal from './SiteClusterCreateModal';
import SiteClusterComponent from './SiteClusterComponent';

function SiteDevices() {
  const { siteId } = useParams();
  const [data] = useSiteDetails();
  const { isPlatformOwner, isPlatformEngineer } = useUserRoles();
  const isValidUser = isPlatformOwner || isPlatformEngineer;
  const [clusterDetail, setCluseterDetail] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [AddNewClusterDialog, showAddNewClusterDialog] = useModal(
    SiteClusterCreateModal,
    { title: 'Add Cluster', setCluseterDetail, setLoading }
  );

  useEffect(() => {
    setLoading(true);
    pepApiRequest({
      method: RequestMethod.Get,
      url: generatePath(API_SITE_CLUSTERS, { siteId }),
      skipErrorAlert: true,
      skipErrorCodes: [500],
    })
      .then((response) => {
        setCluseterDetail(response);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let intervalId;
    const hasClusters = clusterDetail?.clustersDetail?.length > 0;

    if (hasClusters) {
      intervalId = setInterval(() => {
        pepApiRequest({
          method: RequestMethod.Get,
          url: generatePath(API_SITE_CLUSTERS, { siteId }),
        }).then((response) => {
          setCluseterDetail(response);
          if (
            response.state === 'active' &&
            data?.status === Status.InProgress
          ) {
            pepApiRequest({
              method: RequestMethod.Put,
              url: generatePath(API_SITE_UPDATE_SITE_STATUS, {
                siteId,
              }),
              params: {
                status: 'Active',
              },
            });
          }
        });
      }, 30000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [clusterDetail?.clustersDetail?.length, siteId, data?.status]);

  return (
    <>
      <DataTableWrapper
        data-testid="solution-files-whitelist-wrapper"
        my={3}
        mb={2}
        title="Clusters"
        actionsPanel={
          <DataTableWrapperActionButton
            onClick={showAddNewClusterDialog}
            startIcon={<Add />}
            disabled={
              (data?.status !== SiteStatus.Active &&
                data?.status !== SiteStatus.InProgress) ||
              !isValidUser
            }
          >
            Add new cluster
          </DataTableWrapperActionButton>
        }
        searchBar={false}
      >
        {AddNewClusterDialog}
      </DataTableWrapper>
      {clusterDetail?.clustersDetail?.map((cluster: any) => (
        <SiteClusterComponent
          data={data}
          cluster={cluster}
          clusterDetail={clusterDetail}
        />
      ))}
      {loading && <PageCardLoader />}
      {!loading &&
        (!clusterDetail ||
          Object.keys(clusterDetail).length === 0 ||
          !clusterDetail.clustersDetail ||
          clusterDetail.clustersDetail.length === 0) && (
          <Box>
            <Typography variant="body2" color="#A5A5A5" align="center">
              No Clusters to display
            </Typography>
          </Box>
        )}
    </>
  );
}

export default SiteDevices;
